import React from 'react'

import { CreditCardV2 } from '~/components/credit-card'
import { i18n } from '~/i18n'
import { TokenizedCreditCard, PaymentService } from '~/types'

import {
  AffirmLogo,
  LogoWrapper,
  NoPaymentRequiredMessage,
} from '../payment-summary.styles'

type Props = {
  paymentService: PaymentService
  creditCard?: TokenizedCreditCard
}

export default function PaymentMethod(props: Props) {
  const { creditCard, paymentService } = props

  if (paymentService === 'payment_not_required') {
    return (
      <NoPaymentRequiredMessage>
        {i18n.t('pages.review.payment_details.payment_not_required_message')}
      </NoPaymentRequiredMessage>
    )
  } else if (
    (creditCard && creditCard.paymentType === 'affirm') ||
    paymentService === 'affirm'
  ) {
    return (
      <LogoWrapper>
        <AffirmLogo type="black_on_white" />
      </LogoWrapper>
    )
  } else if (creditCard && creditCard.paymentType !== 'affirm') {
    return <CreditCardV2 creditCard={creditCard} />
  } else {
    return null
  }
}
